import { BiBuildings } from 'react-icons/bi';
import { FiBriefcase, FiCreditCard, FiLayers, FiUser, FiUsers } from 'react-icons/fi';
import { HiOutlineViewGrid } from 'react-icons/hi';
import { MdAccessTime, MdOutlinePayments } from 'react-icons/md';
import { RiTeamLine } from 'react-icons/ri';
import { WiTime4 } from 'react-icons/wi';
import { LailaOrbIcon } from '@vyce/core/src/views/ai/components/launcher/LailaOrb';
import { LuFileClock } from 'react-icons/lu';
import { FiLifeBuoy } from 'react-icons/fi';
import { FiMessageCircle } from 'react-icons/fi';
import { FiFileText } from 'react-icons/fi';
import { LuBanknote, LuClipboardCheck } from 'react-icons/lu';

import { INTERFACE_PERMISSIONS, NavItem } from '@vyce/core/src/types';

export enum ROUTES_WITHOUT_NAVIGATION {
  EMAIL_NOTIFICATIONS = '/email-notifications',
  MAINTENANCE = '/maintenance',
}

export const EMPLOYER_NAV_ITEMS: NavItem[] = [
  { name: 'Dashboard', icon: HiOutlineViewGrid, link: '/dashboard' },
  {
    name: 'Hiring',
    icon: FiBriefcase,
    link: '/hiring/live',
    permissions: [INTERFACE_PERMISSIONS.CONNECT],
  },
  // Messages and Forms are subscription-gated, not permission-gated — the
  // permission catalogue has no module for either.
  { name: 'Messages', icon: FiMessageCircle, link: '/messages' },
  {
    name: 'Teams',
    icon: FiUsers,
    link: '/teams/dashboard',
    permissions: [INTERFACE_PERMISSIONS.TEAMS],
  },
  {
    name: 'Forms',
    icon: FiFileText,
    link: '/forms',
  },
  {
    name: 'Projects',
    icon: FiLayers,
    link: '/projects',
    permissions: [INTERFACE_PERMISSIONS.TEAMS],
  },
  {
    name: 'Time & Attendance',
    icon: WiTime4,
    link: '/time/dashboard',
    permissions: [INTERFACE_PERMISSIONS.TIME],
  },
  {
    name: 'Payroll',
    icon: MdOutlinePayments,
    link: '/payroll',
    permissions: [INTERFACE_PERMISSIONS.PAYROLL, INTERFACE_PERMISSIONS.PAYROLL_OUTSOURCED],
  },
  // Separate early-stage products on their own subdomains, opened in a new tab.
  {
    name: 'Inspections',
    icon: LuClipboardCheck,
    link: 'https://inspections.vyce.io',
    isBeta: true,
  },
  {
    name: 'Price Work',
    icon: LuBanknote,
    link: 'https://pricework.vyce.io',
    isBeta: true,
  },
  {
    name: 'Vyce AI',
    icon: LailaOrbIcon,
    link: '/vyce-ai',
  },
  {
    name: 'User Management',
    icon: RiTeamLine,
    link: '/user-management/users',
    permissions: [INTERFACE_PERMISSIONS.STAFF_MANAGEMENT],
    isBottom: true,
  },
  {
    // Billing is the one module with nothing to show without the right — no
    // sidebar item, and /subscriptions redirects to the dashboard.
    name: 'Subscription & Billing',
    icon: FiCreditCard,
    link: '/subscriptions',
    permissions: [INTERFACE_PERMISSIONS.BILLING],
    hideWithoutPermissions: true,
    isBottom: true,
  },
  {
    name: 'My Companies',
    icon: BiBuildings,
    link: '/companies',
    isBottom: true,
  },
  {
    name: 'Help & Contact',
    icon: FiLifeBuoy,
    link: '/help',
    isBottom: true,
  },
  { name: 'Profile', icon: FiUser, link: '/profile', isBottom: true },
];

export const EMPLOYEE_NAV_ITEMS: NavItem[] = [
  { name: 'Dashboard', icon: HiOutlineViewGrid, link: '/dashboard' },
  { name: 'Time Logs', icon: MdAccessTime, link: '/timelogs/logs' },
  { name: 'Timesheets', icon: LuFileClock, link: '/employee-payroll' },
  { name: 'Payments', icon: MdOutlinePayments, link: '/payments' },
  {
    name: 'Vyce AI',
    icon: LailaOrbIcon,
    link: '/vyce-ai',
  },
  { name: 'Help & Contact', icon: FiLifeBuoy, link: '/help-contact', isBottom: true },
  { name: 'Profile', icon: FiUser, link: '/profile', isBottom: true },
];

export const DEFAULT_NAV_ITEMS: NavItem[] = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    icon: HiOutlineViewGrid,
    disabled: true,
  },

  {
    name: 'Profile',
    link: '/profile',
    icon: FiUser,
    isBottom: true,
    disabled: true,
  },
];
